export const SHOW_INGREDIENT_DETAILS: 'SHOW_INGREDIENT_DETAILS' = 'SHOW_INGREDIENT_DETAILS';
export const HIDE_INGREDIENT_DETAILS: 'HIDE_INGREDIENT_DETAILS' = 'HIDE_INGREDIENT_DETAILS';
